module.exports = new __parcel__URL__("earth_observatory.b21c3065.png").toString();